








































































































































































import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator';
import Decisions from '@/store/modules/Decisions';
import { getModule } from 'vuex-module-decorators';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import { NotificationEventBus } from '@/EventBus';
import _ from 'lodash';
import ListInputDialog from '@/components/forms/ListInputDialog.vue';
import ChoiceInputDialog from '@/components/choice-input/ChoiceInputDialog.vue';
import Choices, { Choice } from '@/store/modules/Choices';
import { Decision } from '@/api/model/Decision';
import ChoiceFileImporter from '@/views/ChoiceImport/ChoiceFileImporter.vue';
import { Viewpoint } from '@/api/model/Viewpoint';
import Viewpoints from '@/store/modules/Viewpoints';
import BasicInputForm from '@/components/forms/BasicInputForm.vue';

const choicesModule = getModule(Choices);
const decisionsModule = getModule(Decisions);
const workspaceOptionsModule = getModule(WorkspaceOptions);
const viewpointsModule = getModule(Viewpoints);

@Component({
    components: {
        ListInputDialog,
        ChoiceInputDialog,
        BasicInputForm,
        ChoiceFileImporter,
    },
})
export default class ChoiceCreatorButton extends Vue {
    
    @Prop({ default: 'NEW', type: String })
    btnText!: string;

    @Prop({ default: false, type: Boolean })
    menuRight!: boolean;

    @Prop({ default: false, type: Boolean })
    menuBottom!: boolean;

    @Prop({ default: false, type: Boolean })
    offsetX!: boolean;
    @Prop({ default: false, type: Boolean })
    offsetY!: boolean;

    @Prop({ default: false, type: Boolean })
    menuLeft!: boolean;

    private menuShow = false;
    private refreshing = false;
    private addToList = false;
    private createViewpointDialog = false;
    private adding = false;
    private selectedViewpoints = [];
    private generateViewpointDialog = false;

    get pluralViewpointLabel() {
        return decisionsModule.pluralViewpointLabel;
    }

    get singularViewpointLabel() {
        return decisionsModule.singularViewpointLabel;
    }

    get activeViewpointList() {
        return workspaceOptionsModule.activeViewpointLists;
    }

    get allowGenerateViewpoints() {
        return workspaceOptionsModule.allowGenerateViewpoints;
    }

    set allowGenerateViewpoints(val: boolean) {
        workspaceOptionsModule.setAllowGenerateViewpoints(val);
    }

    get viewpointList(): Viewpoint[] {
        return viewpointsModule.decisionViewpoints || [];
    }

    // Create Viewpoint(s) from a List
    private async createViewpointsFromList(payload: any) {
        let list = payload.names;
        let addToList = payload.addToList;
        let results = [];
        this.refreshing = true;
        if (list.length) {
            let viewpoints = list
                .filter((l) => l)
                .map((name) => {
                    return {
                        name: name,
                        addToList: addToList,
                    };
                });
            viewpoints.forEach((v: any) => {
                this.createViewpoint(v);
            });
        }
        this.refreshing = false;
    }

    private async createViewpoint(viewpoint: any) {
        if (!this.selectedDecision) return;
        this.adding = true;
        let sampleViewpoint = _.cloneDeep(viewpoint);
        NotificationEventBus.emitProcessingMessage();
        this.createViewpointDialog = false;
        try {
            let res = await decisionsModule.createDecisionViewpoint({
                decisionId: this.selectedDecision.decisionId,
                name: viewpoint.name,
                description: viewpoint.description,
            });
            if (
                sampleViewpoint.addToList &&
                this.activeViewpointList?.length > 0 &&
                this.addToList
            ) {
                decisionsModule.addViewpointToActiveLists(res.viewpointId);
            }
            NotificationEventBus.emitSuccessMessage();
        } catch (err) {
            NotificationEventBus.emitFailedMessage(err);
        }
        // console.log(viewpoint);
        this.adding = false;
    }

    private async addToLists(payload: string[]) {
        console.log(payload);
        await decisionsModule.addViewpointsToSelectLists({
            viewpoints: this.selectedViewpoints,
            listIds: payload,
        });
    }
    get pluralChoiceLabel() {
        return decisionsModule.pluralChoiceLabel;
    }
    get singularChoiceLabel() {
        return decisionsModule.singularChoiceLabel;
    }

    get selectedDecision(): Decision {
        return decisionsModule.selectedDecision;
    }

    get activeChoiceList(): string[] {
        return workspaceOptionsModule.activeChoiceLists;
    }
    // Create Viewpoint(s) from a List

    private async createChoicesFromList(payload: any) {
        let list = payload.names;
        let addToList = _.clone(payload.addToList);
        if (list.length) {
            let choices = list
                .filter((l) => l)
                .map((name) => {
                    return {
                        name: name,
                    } as Choice;
                });
            this.refreshing = true;
            let newChoices = await choicesModule.createChoices(choices);
            if (addToList && newChoices) {
                for (let choice of Object.values(newChoices)) {
                    decisionsModule.addChoiceToActiveLists(choice.id);
                }
            }
            choicesModule.fetchChoices();
            this.refreshing = false;
        }
    }

    private async refresh() {
        this.refreshing = true;
        await choicesModule.fetchChoices();
        this.refreshing = false;
    }
}
